import React, { useEffect, useState } from 'react';
import { values, take, omit, flatten } from "lodash";
import Notification from "../common/notification";
import { inOneOfAllowedMessages } from '../common/navigation';
import HiddenFields from "./HiddenFields";
import Form from "./Form";
import { WithDataContext } from "./data-context";

const Index = ({ options, data, allErrors }) => {
  const [ notificationObject, setNotificationObject ] = useState(null);

  const submitForm = (ev) => {
    if (
      !ev.data ||
      typeof (ev.data) !== "object" ||
      !inOneOfAllowedMessages(ev.data)
    ) {
      return;
    }
    window.document.getElementById("shelf-shot-cart").submit();
  };

  useEffect(() => {
    window.addEventListener("message", submitForm);
    return () => {
      window.removeEventListener('message', submitForm);
    };
  }, []);

  useEffect(() => {
    const firstError = take(flatten(values(omit(allErrors, 'problematic_shelf_indexes'))), 1);
    const errorText = (firstError || []).join('; ');
    if (errorText) {
      setNotificationObject({ message: errorText, success: false });
    }
  }, []);

  return (
    <WithDataContext data={ data } options={ options } errors={ allErrors }>
      <HiddenFields />
      <Form />
      <Notification
        messageObject={ notificationObject }
        onDeactivate={ () => { setNotificationObject(null); } }
        interval={ 10 }
      />
    </WithDataContext>
  );
};

export default Index;
